import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect, useState, useContext, lazy, Suspense } from "react"; // Aggiungo lazy e Suspense per il caricamento dinamico
import { useLocation } from "react-router-dom"; // Importo useLocation per ottenere la query string
import LoginAuth from "../Login/LoginAuth"; // Importazione normale per LoginAuth, dato che viene utilizzato di default
import ModalComponent from "../Body/UtilityComponent/ModalComponent"; // Importazione normale per ModalComponent
import Repo from "../Api_backend/Repo"; // Importazione per chiamate API
import { Context } from "../App"; // Importazione del contesto globale
import { jwtDecode } from "jwt-decode"; // Importazione jwtDecode per decodificare il token

// Importo dinamicamente i componenti per migliorare le prestazioni del caricamento iniziale
const RegistrationConfirm = lazy(() => import("../Login/RegistrationConfirm"));
const PasswordResetConfirm = lazy(() =>
  import("../Login/PasswordResetConfirm")
);
const TouristCard = lazy(() => import("../Body/TouristCard/TouristCard"));
const HomeStruttura = lazy(() =>
  import("../Body/ResponsabileStruttura/HomeStruttura")
);
const ScansioneQRCode = lazy(() =>
  import("../Body/ResponsabilePOI/ScansioneQRCode")
);
const ValidazioneScansione = lazy(() =>
  import("../Body/ResponsabilePOI/ValidazioneScansione")
);
const CronologiaCard = lazy(() =>
  import("./ResponsabileStruttura/CronologiaCard")
);
const CronologiaScan = lazy(() => import("./ResponsabilePOI/CronologiaScan"));
const HomeOperatore = lazy(() => import("./Operatore/HomeOperatore"));
const ValidazionePOI = lazy(() => import("./Operatore/ValidazionePOI"));
const Statistiche = lazy(() => import("./Operatore/Statistiche"));
const NuovoPOI = lazy(() => import("./Operatore/NuovoPOI"));

// Funzione per ottenere la query string
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Body(props) {
  const [cipher, setCipher] = useState(null);
  const [id, setId] = useState(null);
  const [cfPiva, setCfPiva] = useState(null);
  const [ruolo, setRuolo] = useState("noLoggin"); // Stato iniziale di ruolo come "noLoggin"
  const [showModalModify, setShowModalModify] = useState(false); // Stato del modal

  const { apiToken } = useContext(Context); // Uso del contesto per ottenere apiToken
  const decoded = apiToken ? jwtDecode(String(apiToken)) : ""; // Decodifico il token se presente
  const query = useQuery(); // Ottengo la query string

  useEffect(() => {
    const savedData = localStorage.getItem("savedData");
    if (savedData && savedData !== "undefined") {
      setRuolo("struttura");
      props.setDataStruttura(true);
    } else if (query.get("auth")) {
      const auth = query.get("auth");
      setCipher(auth);
      Repo.getAuthStruttura(auth)
        .then((response) => {
          if (response.data !== "scaduto") {
            const [id, descriptCfIva] = String(response.data).split("_");
            setId(id);
            setCfPiva(descriptCfIva);
            setRuolo("struttura");
            props.setDataStruttura(true);
            localStorage.setItem("savedData", id);
            localStorage.setItem("savedDataCF", descriptCfIva);
            sessionStorage.setItem("loginAuth", 1);
          } else {
            setShowModalModify(true); // Apro il modal in caso di autenticazione scaduta
          }
        })
        .catch(console.log);
    } else if (apiToken) {
      setRuolo(decoded.role === "USER" ? "responsabilePOI" : "operatore"); // Setto il ruolo in base al token decodificato
    }
  }, []);

  const toggleModalAuth = () => setShowModalModify(!showModalModify); // Funzione per togglare il modal

  const redirectLogin = () => {
    window.location.href =
      "https://otranto.servizilocalispa.it/EDGT/Edgt_AccessManager/Login.aspx"; // Reindirizzamento al login
  };

  return (
    <main role="main" className="main-body">
      <div className="container mb-4 mt-3">
        <Suspense fallback={<div>Caricamento...</div>}>
          {" "}
          {/* Fallback per il caricamento dinamico */}
          <Routes>
            {ruolo === "struttura" && (
              <>
                <Route
                  path="/cronologia"
                  element={<CronologiaCard subfolder={props.subfolder} />}
                />
                <Route
                  path="/touristcard"
                  element={<TouristCard subfolder={props.subfolder} />}
                />
                <Route
                  path="*"
                  element={<HomeStruttura subfolder={props.subfolder} />}
                />
              </>
            )}
            {ruolo === "responsabilePOI" && (
              <>
                <Route
                  path="*"
                  element={<ScansioneQRCode subfolder={props.subfolder} />}
                />
                <Route
                  path="/validazioneScansione"
                  element={<ValidazioneScansione subfolder={props.subfolder} />}
                />
                <Route
                  path="/cronologiaScan"
                  element={<CronologiaScan subfolder={props.subfolder} />}
                />
              </>
            )}
            {ruolo === "operatore" && (
              <>
                <Route
                  path="*"
                  element={<HomeOperatore subfolder={props.subfolder} />}
                />
                <Route
                  path="/statistiche"
                  element={<Statistiche subfolder={props.subfolder} />}
                />
                <Route
                  path="/validazionePOI"
                  element={<ValidazionePOI subfolder={props.subfolder} />}
                />
                <Route
                  path="/NuovoPOI"
                  element={<NuovoPOI subfolder={props.subfolder} />}
                />
              </>
            )}
            {ruolo === "noLoggin" && (
              <>
                <Route
                  path="*"
                  element={<LoginAuth subfolder={props.subfolder} />}
                />
                <Route
                  path="/RegistrationConfirm"
                  element={<RegistrationConfirm subfolder={props.subfolder} />}
                />
                <Route
                  path="/PasswordResetConfirm"
                  element={<PasswordResetConfirm subfolder={props.subfolder} />}
                />
              </>
            )}
          </Routes>
        </Suspense>
        <ModalComponent
          toggleModal={toggleModalAuth}
          isOpen={showModalModify}
          header="Autenticazione non valida, cliccando OK verrai reindirizzato al login per le strutture ricettive."
          buttonConfirm="OK"
          function={redirectLogin}
        />
      </div>
    </main>
  );
}

export default Body;
